import React, { Component } from 'react';
import ErrorBoundary from '../../shared/ErrorBoundary.js';
import BundleCard from './BundleCard.js';
// This component is the application entry point

class App extends Component {
	constructor(props) {
		super(props);
		console.info('Bundles Comp:: v.1.0');
	}

	render() {
		return (
			<ErrorBoundary>
				<BundleCard bundleInfo={this.props.bundleInfo} appWrapper={this.props.appWrapper} total={this.props.total} isLast={this.props.isLast} />
			</ErrorBoundary>
		);
	}
}

export default App;
